import Vuex from "vuex";
import Vue from "vue";
import { postRequest } from "../../src/assets/utils/api";
import createPersistedPlugin from "./createPersistedPlugin.js";
const persistedPlugin = createPersistedPlugin();
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    payFlag: false,
    accessRouter: []
  },
  mutations: {
    setPayFlag(state, status) {
      state.payFlag = status;
    },

    setPayPwdStatus(state, data) {
      state.payPwdStatus = data;
    },
    setAccessRouter(state, data) {
      state.accessRouter = data;
    }
  },
  actions: {
    GetPayPwdStatus({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        postRequest({
          service: "App.UserExt.GetSecurity",
          token: localStorage.getItem("token"),
          user_id: localStorage.getItem("user_id")
        }).then(res => {
          if (res.data.ret == 200) {
            let data = res.data.data.paypwd;
            // let data=false;
            commit("setPayPwdStatus", data);
            resolve(data);
          }
        });
      });
    }
  },
  plugins: [persistedPlugin]
});
export default store;
